import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'auth-container',
    template: `
        <div class="auth-container">
            <div class="texture-top"></div>
            <div class="auth-warpper d-flex w-100 h-100 align-items-center justify-content-center ">
                <auth-login-form class="login-component-form position-relative"></auth-login-form>
            </div>
            <div class="texture-bottom"></div>
        </div>
    `,
    styleUrls: ['./auth.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthContainer {
    constructor() {}
}
